import ShopListView from '@global/gtm/class/shopListClass';
import {
  fireViewItemListGAEvent,
  fireEventPromotionBanner,
  fireListCategoryPushEvent,
} from '@global/gtm/base';

export default function fireShopListViewEvent() {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();

  fireListCategoryPushEvent(shopListView.category);

  fireViewItemListGAEvent({
    itemListName: shopListView.getItemListName(),
    items: shopListView.getListInfo(),
  });
}

export function firePromotionEvent() {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();

  const listItems = shopListView.getListInfo();
  const promotion = ShopListView.getPromotionInfo();

  if (promotion) {
    fireEventPromotionBanner({
      promotionTargetUrl: `促銷活動--${window.PictureContainer}`,
      promotionItems: listItems,
      promotionCreativeName: promotion.imgLink,
      promotionCreativeSlot: promotion.clickName,
    });
  }
}

/**
 * URLiving 搜尋結果頁所使用的 GA 事件
 *
 * @param {Array} hotSearchList - 關鍵字列表
 */
export function fireShopListSearchEvent(hotSearchList) {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();
  const isHotSearch = ShopListView.checkIsHotSearch(hotSearchList);

  let itemListName = '';

  if (window.TotalCount === 0) {
    itemListName = isHotSearch.isHotSearch
      ? `關鍵字熱字--${isHotSearch.keyword}推薦產品列表`
      : `關鍵字搜尋--${isHotSearch.keyword}推薦產品列表`;

    fireViewItemListGAEvent({
      itemListName,
      items: shopListView.getRecommendListInfo(itemListName),
    });
  } else {
    itemListName = isHotSearch.isHotSearch
      ? `關鍵字熱字--${isHotSearch.keyword}產品列表`
      : `關鍵字搜尋--${isHotSearch.keyword}產品列表`;

    fireViewItemListGAEvent({
      itemListName,
      items: ShopListView.getSearchListInfo(isHotSearch, itemListName),
    });
  }
}

/**
 * 其他客製品牌搜尋結果頁所使用的 GA 事件 for 商品列表
 *
 * @param {Array} hotSearchList - 關鍵字列表
 */
export function fireSearchListEvent(hotSearchList) {
  window.dataLayer = window.dataLayer || [];

  const isHotSearch = ShopListView.checkIsHotSearch(hotSearchList);

  if (window.TotalCount !== 0) {
    const itemListName = isHotSearch.isHotSearch
      ? `關鍵字熱字--${isHotSearch.keyword}產品列表`
      : `關鍵字搜尋--${isHotSearch.keyword}產品列表`;

    fireViewItemListGAEvent({
      itemListName,
      items: ShopListView.getSearchListInfo(isHotSearch, itemListName),
    });
  }
}

/**
 * 其他客製品牌搜尋結果頁所使用的 GA 事件 for 推薦列表
 *
 * @param {Array} hotSearchList - 關鍵字列表
 */
export function fireSearchResultRecommendEvent(hotSearchList, recommendData) {
  window.dataLayer = window.dataLayer || [];

  const shopListView = new ShopListView();
  const isHotSearch = ShopListView.checkIsHotSearch(hotSearchList);

  const itemListName = isHotSearch.isHotSearch
    ? `關鍵字熱字--${isHotSearch.keyword}推薦產品列表`
    : `關鍵字搜尋--${isHotSearch.keyword}推薦產品列表`;

  fireViewItemListGAEvent({
    itemListName,
    items: shopListView.getSearchRecommendListInfo(itemListName, recommendData),
  });
}
